import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import * as components from './';

class AuthRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/auth/login" exact component={components.LoginContainer} />
        <Route path="/auth/signup" exact component={components.SignupContainer} />
        <Route path="/auth/signup/:userId/:code" exact component={components.SignupContainer} />
        <Route path="/auth/forgotPassword" exact component={components.ForgotPasswordContainer} />
        <Route path="/auth/resetPassword/:userId/:code" exact component={components.ResetPasswordContainer} />
      </Switch>
    );
  }
}

export default AuthRoutes;



// WEBPACK FOOTER //
// ./src/modules/auth/components/AuthRoutes.js